import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/Home.vue";
import Login from "@/views/Auth/Login.vue";
import CustomersOverview from "@/views/Customers/CustomersOverview.vue";
import CustomerData from "@/views/Customers/CustomerData.vue";
import CustomerContacts from "@/views/Customers/CustomerContacts.vue";
import CustomerContactDetails from "@/views/Customers/CustomerContactDetails.vue";
import CustomerParticipants from "@/views/Customers/CustomerParticipants.vue";
import CustomerParticipantDetails from "@/views/Customers/CustomerParticipantDetails.vue";
import AdditionalOperators from "@/views/Settings/Operator/AdditionalOperators.vue";
import OperatorGeneralSettings from "@/views/Settings/Operator/GeneralSettings.vue";
import FacilityGeneralSettings from "@/views/Settings/Facility/GeneralSettings.vue";
import VenueGeneralSettings from "@/views/Settings/Venue/GeneralSettings.vue";
import VenueImages from "@/views/Settings/Venue/Images.vue";
import VenuePrices from "@/views/Settings/Venue/Prices.vue";
import VenueCalendar from "@/views/Venue/Calendar.vue";
import VenueScheduler from "@/views/Venue/Scheduler.vue";
import VenueTimetable from "@/views/Venue/Timetable.vue";
import VenuePriceDetails from "@/views/Settings/Venue/PriceDetails.vue";
import Users from "@/views/Settings/User/Users.vue";
import UserDetails from "@/views/Settings/User/UserDetails.vue";
import Events from "@/views/Settings/Event/Event/Events.vue";
import EventDetails from "@/views/Settings/Event/Event/EventDetails.vue";
import EventDateSettings from "@/views/Settings/Event/Event/EventDateSettings.vue";
import EventPrices from "@/views/Settings/Event/Event/EventPrices.vue";
import EventPriceDetails from "@/views/Settings/Event/Event/EventPriceDetails.vue";
import EventAppointments from "@/views/Settings/Event/Event/EventAppointments";
import EventAppointmentDetails from "@/views/Settings/Event/Event/EventAppointmentDetails";
import Instructors from "@/views/Settings/Event/Instructor/Instructors.vue";
import InstructorDetails from "@/views/Settings/Event/Instructor/InstructorDetails.vue";
import ExternalVenues from "@/views/Settings/Event/ExternalVenue/ExternalVenues";
import ExternalVenueDetails from "@/views/Settings/Event/ExternalVenue/ExternalVenueDetails";
import EventCategories from "@/views/Settings/Event/Category/EventCategories.vue";
import EventCategoryDetails from "@/views/Settings/Event/Category/EventCategoryDetails.vue";
import Groups from "@/views/Settings/Group/Groups.vue";
import GroupDetails from "@/views/Settings/Group/GroupDetails.vue";
import Organizations from "@/views/Settings/Organization/Organizations.vue";
import OrganizationDetails from "@/views/Settings/Organization/OrganizationDetails.vue";
import InventoryProducts from "@/views/Settings/Inventory/InventoryProducts.vue";
import InventoryProductDetails from "@/views/Settings/Inventory/InventoryProductDetails";
import BookingInventoryProductDetails from "@/views/Bookings/InventoryProduct/BookingInventoryProductDetails";
import BookingInventoryProducts from "@/views/Bookings/InventoryProduct/BookingInventoryProducts";
import BookingVenueDetails from "@/views/Bookings/Venue/BookingVenueDetails";
import BookingVenues from "@/views/Bookings/Venue/BookingVenues";
import BookingEventDetails from "@/views/Bookings/Event/BookingEventDetails";
import BookingEvents from "@/views/Bookings/Event/BookingEvents";
import UserEvents from "@/views/Event/Events.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/customers",
    name: "CustomersOverview",
    component: CustomersOverview
  },
  {
    path: "/customers/new",
    name: "NewCustomer",
    component: CustomerData
  },
  {
    path: "/customers/:customer_id/data",
    name: "CustomerData",
    component: CustomerData
  },
  {
    path: "/customers/:customer_id/contacts",
    name: "CustomerContacts",
    component: CustomerContacts
  },
  {
    path: "/customers/:customer_id/contacts/new",
    name: "NewCustomerContact",
    component: CustomerContactDetails
  },
  {
    path: "/customers/:customer_id/contacts/:contact_person_id",
    name: "CustomerContactDetails",
    component: CustomerContactDetails
  },
  {
    path: "/customers/:customer_id/participants",
    name: "CustomerParticipants",
    component: CustomerParticipants
  },
  {
    path: "/customers/:customer_id/participants/new",
    name: "NewCustomerParticipant",
    component: CustomerParticipantDetails
  },
  {
    path: "/customers/:customer_id/participants/:participant_id",
    name: "CustomerParticipantDetails",
    component: CustomerParticipantDetails
  },
  {
    path: "/settings/operators/:id",
    name: "OperatorGeneralSettings",
    component: OperatorGeneralSettings
  },
  {
    path: "/settings/operators/:id/additional-operators",
    name: "AdditionalOperators",
    component: AdditionalOperators
  },
  {
    path: "/settings/facilities/:id",
    name: "FacilityGeneralSettings",
    component: FacilityGeneralSettings
  },
  {
    path: "/settings/venues/:id",
    name: "VenueGeneralSettings",
    component: VenueGeneralSettings
  },
  {
    path: "/settings/venues/:id/images",
    name: "VenueImages",
    component: VenueImages
  },
  {
    path: "/settings/venues/:id/prices",
    name: "VenuePrices",
    component: VenuePrices
  },
  {
    path: "/settings/venues/:id/prices/new/:price_type",
    name: "NewVenuePrice",
    component: VenuePriceDetails
  },
  {
    path: "/settings/venues/:id/prices/:price_id",
    name: "VenuePriceDetails",
    component: VenuePriceDetails
  },
  {
    path: "/settings/events/events",
    name: "Events",
    component: Events
  },
  {
    path: "/settings/events/events/new",
    name: "NewEvent",
    component: EventDetails
  },
  {
    path: "/settings/events/events/:event_id",
    name: "EventDetails",
    component: EventDetails
  },
  {
    path: "/settings/events/events/:event_id/date-settings",
    name: "EventDateSettings",
    component: EventDateSettings
  },
  {
    path: "/settings/events/events/:event_id/prices",
    name: "EventPrices",
    component: EventPrices
  },
  {
    path: "/settings/events/events/:event_id/prices/new",
    name: "NewEventPrice",
    component: EventPriceDetails
  },
  {
    path: "/settings/events/events/:event_id/prices/:price_id",
    name: "EventPriceDetails",
    component: EventPriceDetails
  },
  {
    path: "/settings/events/events/:event_id/appointments",
    name: "EventAppointments",
    component: EventAppointments
  },
  {
    path: "/settings/events/events/:event_id/appointments/:appointment_id",
    name: "EventAppointmentDetails",
    component: EventAppointmentDetails
  },
  {
    path: "/settings/events/instructors",
    name: "EventInstructors",
    component: Instructors
  },
  {
    path: "/settings/events/instructors/new",
    name: "NewEventInstructor",
    component: InstructorDetails
  },
  {
    path: "/settings/events/instructors/:instructor_id",
    name: "EventInstructorDetails",
    component: InstructorDetails
  },
  {
    path: "/settings/events/venues",
    name: "EventVenues",
    component: ExternalVenues
  },
  {
    path: "/settings/events/venues/new",
    name: "NewEventVenue",
    component: ExternalVenueDetails
  },
  {
    path: "/settings/events/venues/:venue_id",
    name: "EventVenueDetails",
    component: ExternalVenueDetails
  },
  {
    path: "/settings/events/categories",
    name: "EventCategories",
    component: EventCategories
  },
  {
    path: "/settings/events/categories/new",
    name: "NewEventCategory",
    component: EventCategoryDetails
  },
  {
    path: "/settings/events/categories/:category_id",
    name: "EventCategoryDetails",
    component: EventCategoryDetails
  },
  {
    path: "/settings/users",
    name: "UsersOverview",
    component: Users
  },
  {
    path: "/settings/users/new",
    name: "NewUser",
    component: UserDetails
  },
  {
    path: "/settings/users/:user_id",
    name: "UserDetails",
    component: UserDetails
  },
  {
    path: "/settings/groups",
    name: "GroupsOverview",
    component: Groups
  },
  {
    path: "/settings/groups/new",
    name: "NewGroup",
    component: GroupDetails
  },
  {
    path: "/settings/groups/:group_id",
    name: "GroupDetails",
    component: GroupDetails
  },
  {
    path: "/settings/organizations",
    name: "OrganizationsOverview",
    component: Organizations
  },
  {
    path: "/settings/organizations/new",
    name: "NewOrganization",
    component: OrganizationDetails
  },
  {
    path: "/settings/organizations/:organization_id",
    name: "OrganizationDetails",
    component: OrganizationDetails
  },
  {
    path: "/settings/inventory",
    name: "InventoryProducts",
    component: InventoryProducts
  },
  {
    path: "/settings/inventory/new",
    name: "NewInventoryProduct",
    component: InventoryProductDetails
  },
  {
    path: "/settings/inventory/:inventory_product_id",
    name: "InventoryProductDetails",
    component: InventoryProductDetails
  },
  {
    path: "/venues/:id/calendar",
    name: "VenueCalendar",
    component: VenueCalendar
  },
  {
    path: "/venues/scheduler",
    name: "VenueScheduler",
    component: VenueScheduler
  },
  {
    path: "/venues/timetable/week",
    name: "VenueTimetable",
    component: VenueTimetable
  },
  {
    path: "/bookings/inventory-products/new",
    name: "NewBookingInventoryProduct",
    component: BookingInventoryProductDetails
  },
  {
    path: "/bookings/inventory-products/:booking_id",
    name: "BookingInventoryProductDetails",
    component: BookingInventoryProductDetails
  },
  {
    path: "/bookings/inventory-products",
    name: "BookingInventoryProduct",
    component: BookingInventoryProducts
  },
  {
    path: "/bookings/venues",
    name: "BookingVenues",
    component: BookingVenues
  },
  {
    path: "/bookings/venues/new",
    name: "NewBookingVenue",
    component: BookingVenueDetails
  },
  {
    path: "/bookings/venues/:booking_id",
    name: "BookingVenueDetails",
    component: BookingVenueDetails
  },
  {
    path: "/bookings/events",
    name: "BookingEvents",
    component: BookingEvents
  },
  {
    path: "/bookings/events/new",
    name: "NewBookingEvent",
    component: BookingEventDetails
  },
  {
    path: "/bookings/events/:booking_id",
    name: "BookingEventDetails",
    component: BookingEventDetails
  },
  {
    path: "/events",
    name: "UserEvents",
    component: UserEvents
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
